export const UNAUTHORIZED_PREFIX = 'unauthorized:';
export const ACTIVATE_ERROR_CODE = {
  noData: '1001',
  activated: '1002',
  noLicense: '1005',
};
export const ACTIVATE_ERROR_CODES = [
  ACTIVATE_ERROR_CODE.noData,
  ACTIVATE_ERROR_CODE.activated,
];
export const UPDATE_OPERATORS_ERROR_CODE = {
  notExist: 1101,
  noAuthority: 1102,
  overUserLicense: 1103,
  overRemoteSupportLicense: 1105,
  noRemoteSupportLicense: 1106,
  unknown: 9999,
};
export const ANALYSIS_RESULT_CODE = {
  underAnalysis: '1201',
  voiceAnalysisNoLicenseInfo: '1202',
  voiceAnalysisLicenseExceeded: '1203',
  ocrNoLicenseInfo: '1204',
  ocrLicenseExceeded: '1205',
  voiceAnalysisTimeExceeded: '1206',
};
export const REMOTE_SUPPORT_ERROR_CODE = {
  // ！！重要！！i18nメッセージとセットの必要あり
  // createRoom
  /** 通話中:1301 */
  remoteSupportNow: '1301',
  /** ライセンス無し:1303 */
  noLicense: '1303',
  /** ライセンス超過:1304 */
  licenseExceeded: '1304',
  /** 通知エラー:1306 */
  pushError: '1306',
  /** デバイスエラー:1307 */
  deviceError: '1307',
  // getRoomInfo
  /** クライアント退室:1309 */
  clientLeft: '1309',
};
export const DEVICE_AUTH_ERROR_CODE = {
  /** デバイス認証確認が出来なかった:1401 */
  deviceAuthError: '1401',
  /** アクセス制御通知先が未設定:1402 */
  unsetAccessControlNotification: '1402',
};
